import { DatePipe } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { Component, OnInit, Renderer2, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material";
import { ActivatedRoute, Router } from "@angular/router";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs";
import { CookieService } from "src/app/core/services/cookie.service";
import { GeneralService } from "src/app/Service/general.service";
import Swal from "sweetalert2";
import { ViewImageComponent } from "../view-image/view-image.component";
class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

@Component({
  selector: "app-view-email-pp-alert",
  templateUrl: "./view-email-pp-alert.component.html",
  styleUrls: ["./view-email-pp-alert.component.scss"],
})
export class ViewEmailPpAlertComponent implements OnInit {
  breadCrumbItems: Array<{}>;
  isdropdownShow: boolean;
  isLoading: boolean;
  inputValue: string = "";
  dtOptions: DataTables.Settings = {};
  dtOptions1: DataTables.Settings = {};
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtTrigger = new Subject<any>();
  submitted = false;
  user: any;
  currentUser: any;
  UserID: any;
  baseurl: string;
  constructor(
    private datepipe: DatePipe,
    private gs: GeneralService,
    private http: HttpClient,
    public dialog: MatDialog,
    private router: Router
  ) {
    let a = this.router.getCurrentNavigation().extras;
    if (a) {
      if (a.state) {
        this.UserID = a.state.id;
        console.log("thisuserid", this.UserID);
        localStorage.setItem("id", this.UserID);
      }
    }
    if (localStorage.getItem("id")) {
      this.UserID = localStorage.getItem("id");
    }
  }

  ngOnInit() {
    this.getusersbyid();
    this.breadCrumbItems = [
      { label: "User Details", path: "/users/users-users-details" },
      { label: "Email for PP", path: "/", active: true },
    ];
    this.baseurl = this.gs.getBaseurl();
    this.dtOptions = {
      pagingType: "simple_numbers",
      pageLength: 10,
      processing: true,
      serverSide: true,
      // ordering: true,
      searching: false,
      order: [[0, "desc"]],
      ajax: (dataTablesParameters: any, callback) => {
        this.http
          .get<DataTablesResponse>(
            `${this.gs.getEmailPP()}` +
              `${this.UserID}` +
              `${
                dataTablesParameters.length.value != ""
                  ? "?PageSize=" + dataTablesParameters.length
                  : ""
              }` +
              `&PageNo=${
                (dataTablesParameters.start + dataTablesParameters.length) /
                dataTablesParameters.length
              }` +
              `${this.inputValue != "" ? "&search=" + this.inputValue : ""}`
          )
          .subscribe((resp: any) => {
            callback({
              recordsTotal: resp.Count,
              recordsFiltered: resp.Count,
              data: resp.result,
            });
          });
      },
      columns: [
        {
          title: "Id",
          data: null,
          render: (data) => {
            return data.id;
          },
        },
        {
          title: "Publish Date",
          data: null,
          render: (data) => {
            return this.datepipe.transform(data.publish_date, "yyyy-MM-dd");
          },
        },
        {
          title: "Village",
          data: null,
          render: (data) => {
            return data.village ? data.village : "--";
          },
        },
        {
          title: "Taluka",
          data: null,
          render: (data) => {
            return data.taluka ? data.taluka : "--";
          },
        },
        {
          title: "District",
          data: null,
          render: (data) => {
            return data.district ? data.district : "--";
          },
        },
        {
          title: "City Survey Office",
          data: null,
          render: (data) => {
            return data.city_survey_office ? data.city_survey_office : "--";
          },
        },
        {
          title: "Ward",
          data: null,
          render: (data) => {
            return data.ward ? data.ward : "--";
          },
        },
        {
          title: "Image",
          name: "image_path",
          orderable: false,
          data: null,
          render: (data, type, row, meta) => {
            return `<div style="display:flex" ><a class="btn text-primary view" title="View Notice">
            <span class="badge badge-success p-1" URL="${this.baseurl}${data.image_path}">View</span></a>`;
          },
        },
      ],
      drawCallback: () => {
        $(".view").on("click", (e) => {
          this.openDialog(e.target.getAttribute("URL"));
        });
      },
    };
  }
  getusersbyid() {
    this.isLoading = true;
    this.gs.getusersbyid(this.UserID).subscribe(
      (res: any) => {
        this.isLoading = false;
        this.user = res.data[0];
        this.user.mobileno = this.user.MobileNo.split(",");
        this.user.email = this.user.EmailID.split(",");
        localStorage.setItem("PlanId", this.user.plan);
      },
      (error) => {
        this.isLoading = false;
        Swal.fire({
          title: error.status,
          text: "Internal Server Error",
          type: "error",
        });
      }
    );
  }
  openDialog(url): void {
    const dialogRef = this.dialog.open(ViewImageComponent, {
      width: "600px",
      data: { URL: url },
      autoFocus: false,
      maxHeight: "600px",
      disableClose: false,
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log("The dialog was closed");
    });
  }
  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }
  renderData(data) {
    if (data === "" || data === null || data === "null") {
      return "--";
    } else {
      return data;
    }
  }
  ngAfterViewInit() {
    this.dtTrigger.next();
  }
  onSearch() {
    this.rerender();
  }
  onchangeSearch() {
    if (this.inputValue != "") {
      return;
    }
    this.rerender();
  }
}
